import http from "../http-common";

class AdminService {

    getClients = () => http.get("/clients");

    getClient = (client_id) => http.get(`/client/${client_id}`);
  
    updateClient = (client_id, data) => http.put(`/client/${client_id}`, data);

    updateIVR= (digits, user_id) => http.put(`/ivrDesignation/${user_id}`, digits);

    getIVRDesignation = (user_id) => http.get(`/ivrDesignation/${user_id}`);

    getClientIVR = () => http.get(`/ivrLength`);
  
    deleteClient = (client_id) => http.delete(`/client/${client_id}`);

    getClientPhones = () => http.get(`/clientphones`);
  
    getClientEndpoints = () => http.get(`/clientendpoints`);
  
    updatePhone = (data) => http.put(`/clientphone`, data);
  
    deletePhone = (phone_id) => http.delete(`/clientphone/${phone_id}`);

    createNewClient = (data) => http.post("/createClient", data);

    createNewPhone = (data) => http.post("/createPhone", data);
  
    searchNumber = (data) => http.post("/searchNumber", data);

    newEndpoints = () => http.post("/newEndpoints");

    updateUserRole = (user_id, role) => http.put(`/users/${user_id}/${role}`);

    subscribe = (priceId) => http.post(`/create-checkout-session/${priceId}/`);

    cancelSubscription = () => http.post(`/cancelsubscription`);

    getSubscriptionDetails = () => http.get(`/subscriptionDetails`);

    switchPlan = (switch_plan) => http.post(`/switchplan/${switch_plan}`);

    planDetails = () => http.get('/planDetails');

    changePlanPrice = (price_id,new_price) => http.post(`/changePlanPrice/${price_id}/${new_price}`);

    createUser = (data) => http.post(`/users`, data);

    updateUser = (data, user_id) => http.put(`/users/${user_id}`, data);

    getWorkingHours = (client_id) => http.get(`/working-hours/${client_id}`);

    saveWorkingHours = (client_id, hours) => http.post(`/working-hours/${client_id}`, { hours });

    // User Groups Management (legacy methods for backward compatibility)
    // For new code, prefer using userGroupService.js directly
    getUserGroups = (client_id) => http.get(`/userGroups/${client_id}`);

    createUserGroup = (client_id, groupName) => http.post(`/userGroups/${client_id}`, { groupName });

    renameUserGroup = (client_id, oldName, newName) => 
        http.put(`/userGroups/${client_id}/${encodeURIComponent(oldName)}`, { newName });

    deleteUserGroup = (client_id, groupName) => 
        http.delete(`/userGroups/${client_id}/${encodeURIComponent(groupName)}`);

    getAllUsersWithGroups = (client_id) => http.get(`/users/${client_id}/withGroups`);

    getUsersInGroup = (client_id, groupName) => 
        http.get(`/userGroups/${client_id}/${encodeURIComponent(groupName)}/users`);

    updateGroupUsers = (client_id, groupName, userIds) => 
        http.put(`/userGroups/${client_id}/${encodeURIComponent(groupName)}/users`, { userIds });

    getGroupSipEndpoints = (client_id, groupName) => 
        http.get(`/userGroups/${client_id}/${encodeURIComponent(groupName)}/sip`);
}

export default new AdminService();